
// 涨跌色
const UP_DOWN_COLOR = {
    RED_UP: 0, // 红色涨
    GREEN_UP: 1, // 绿色涨
}

const FEGO_PAGE_LANG = {
    CN: 'CN',
    HK: 'HK',
    EN: 'EN',
}

// 语种
const LANGUAGE = {
    [FEGO_PAGE_LANG.CN]: 0, // 简体
    [FEGO_PAGE_LANG.HK]: 1, // 繁体
    [FEGO_PAGE_LANG.EN]: 2, // 英文
}

export {
    UP_DOWN_COLOR,
    LANGUAGE,
    FEGO_PAGE_LANG
}
